import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-currency-euro-circle',
  imports: [],
  templateUrl: './currency-euro-circle.html',
  styleUrl: './currency-euro-circle.scss',
})
export class CurrencyEuroCircle {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
